import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PinPendingChecklist } from "models";

export const useAddPinPendingChecklistMutation = () =>
  useTypedMutation<PinPendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/pin_pending_checklists/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const pinPendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.pinPendingChecklists);
      if (!pinPendingChecklists) return;

      const pinPendingChecklistIdx = pinPendingChecklists.findIndex(p => p.checklist_id === payload.checklist_id && p.pin_type === payload.pin_type);
      if (pinPendingChecklistIdx >= 0) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.pinPendingChecklists, [...pinPendingChecklists, payload]);
    }
  });
